module.exports = __webpack_public_path__ + "static/media/GalleryMain3.ad2dbd2b.jpg";